import React from 'react';

function ChannelVideoList({
  videos,
  selectedVideoIds,
  onToggleVideo,
  onSelectAll,
  onDeselectAll
}) {
  const selectedCount = selectedVideoIds.size;
  const totalCount = videos.length;

  return (
    <div>
      {/* Selection Controls */}
      <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between bg-gray-50">
        <span className="text-sm text-gray-600">
          {selectedCount} of {totalCount} selected
        </span>
        <div className="flex gap-2">
          <button
            onClick={onSelectAll}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            Select All
          </button>
          <span className="text-gray-300">|</span>
          <button
            onClick={onDeselectAll}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            Deselect All
          </button>
        </div>
      </div>

      {/* Video List */}
      <div className="max-h-96 overflow-y-auto">
        {videos.map((video) => (
          <VideoItem
            key={video.videoId}
            video={video}
            isSelected={selectedVideoIds.has(video.videoId)}
            onToggle={() => onToggleVideo(video.videoId)}
          />
        ))}
      </div>
    </div>
  );
}

function VideoItem({ video, isSelected, onToggle }) {
  return (
    <label
      className={`flex items-center gap-3 p-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors ${
        isSelected ? 'bg-primary-50' : ''
      }`}
    >
      <input
        type="checkbox"
        checked={isSelected}
        onChange={onToggle}
        className="w-4 h-4 text-primary-500 border-gray-300 rounded focus:ring-primary-500 flex-shrink-0"
      />

      {/* Thumbnail */}
      <div className="w-24 h-14 flex-shrink-0 bg-gray-200 rounded overflow-hidden">
        {video.thumbnailUrl ? (
          <img
            src={video.thumbnailUrl}
            alt={video.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
        )}
      </div>

      {/* Title & Date */}
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium truncate ${isSelected ? 'text-gray-900' : 'text-gray-700'}`}>
          {video.title || 'Untitled Video'}
        </p>
        {video.publishedAt && (
          <p className="text-xs text-gray-500 mt-0.5">
            {formatDate(video.publishedAt)}
          </p>
        )}
      </div>
    </label>
  );
}

function formatDate(dateString) {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch {
    return '';
  }
}

export default ChannelVideoList;
